import { Route, Routes, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import {
  isTokenValid,
  getActiveInterface,
  getRouteForInterface,
} from './modules/contexts/Auth/RequireAuth';
import Cadastrar from './pages/daf/Cadastrar';
import EsqueciSenha from './pages/daf/EsqueciSenha';
import { Login } from './pages/daf/Login';
import ResetSenha from './pages/daf/ResetSenha';
import SolicitarVinculo from './pages/daf/SolicitarVinculo';
import { MedsusPublicView } from './pages/public/medsus';
import MedsusPublicDetail from './pages/public/medsus/detail';
import AccessDenied from './routes/AccessDenied';
import NotFound from './routes/NotFound';
import TenantRouter from './routes/TenantRouter';
import GlobalStyle from './utils/globalStyles';

function App() {
  const authenticated = isTokenValid();

  return (
    <div className="App">
      <GlobalStyle />
      <Routes>
        <Route
          path="/"
          element={
            authenticated ? (
              <Navigate
                to={getRouteForInterface(getActiveInterface())}
                replace
              />
            ) : (
              <Login />
            )
          }
        />
        <Route
          path="/cadastrar"
          element={authenticated ? <Navigate to="/" replace /> : <Cadastrar />}
        />
        <Route path="/esqueci-senha" element={<EsqueciSenha />} />
        <Route path="/reset-senha" element={<ResetSenha />} />
        <Route path="/:tenant/*" element={<TenantRouter />} />
        <Route path="/solicitar-vinculo" element={<SolicitarVinculo />} />
        <Route path="/acesso-negado" element={<AccessDenied />} />
        <Route path="/medsus" element={<MedsusPublicView />} />
        <Route path="/medsus/:id" element={<MedsusPublicDetail />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
